module.exports = __webpack_public_path__ + "public/img/PMS - Header Banner 3.988efa31.png";